import React from "react";
import { Button, ClassNameProps, Column, If, Modal, Row, StyleProps } from "@hex-insights/core";
import { SlimEmptyView } from "../../../../Components/Empty";
import { Student, StudentNameFragment } from "../../../../Utilities";
import { CardStudentMedicalContact, StudentMedicalContactCard } from "../Card";
import { StudentMedicalContactStudentListModal } from "../StudentListModal";
import styles from "./styles.module.css";

const maxDisplayed = 2;

export type StudentMedicalContactStudentListSectionProps = {
	isLoading?: boolean;
	student: Pick<Student, "id"> & StudentNameFragment;
	studentMedicalContacts: CardStudentMedicalContact[] | null | undefined;
} & Partial<ClassNameProps & StyleProps>;

export function StudentMedicalContactStudentListSection({
	isLoading = false,
	studentMedicalContacts,
	student,
	className,
	style,
}: StudentMedicalContactStudentListSectionProps) {
	const { isModalOpen, openModal, closeModal } = Modal.useToggle();

	if (isLoading && !studentMedicalContacts) {
		return (
			<SlimEmptyView className={className} style={style}>
				Loading...
			</SlimEmptyView>
		);
	}

	if (!studentMedicalContacts || studentMedicalContacts.length === 0) {
		return (
			<SlimEmptyView className={className} style={style}>
				No medical contacts listed
			</SlimEmptyView>
		);
	}

	return (
		<React.Fragment>
			<Column justify="spaced-start" className={className} style={style}>
				<Row justify="spaced-start">
					{studentMedicalContacts.slice(0, maxDisplayed).map((studentMedicalContact) => (
						<StudentMedicalContactCard
							key={studentMedicalContact.id}
							student={student}
							studentMedicalContact={studentMedicalContact}
							className={styles["card"]}
						/>
					))}
				</Row>

				<If condition={studentMedicalContacts.length > maxDisplayed}>
					<Row justify="flex-end">
						<Button variant="link" size="small" onClick={openModal}>
							View All
						</Button>
					</Row>
				</If>
			</Column>

			<Modal.If condition={isModalOpen}>
				<StudentMedicalContactStudentListModal
					student={student}
					studentMedicalContacts={studentMedicalContacts}
					onClose={closeModal}
				/>
			</Modal.If>
		</React.Fragment>
	);
}
